export enum DiningAvailabilityError {
  RESTAURANT_LIMIT = 'RESTAURANT_LIMIT',
  PER_PACKAGE_LIMIT = 'PER_PACKAGE_LIMIT',
}

export const DINING_DAY_AT_SEA_PORT_CODE = 'SEA';

export enum DiningFlowEntryPoint {
  /** Opened from a product card in shop/carousel – fresh purchase flow. */
  PRODUCT_CARD = 'PRODUCT_CARD',
  /** Opened from the cart page – reservation management on an item already in cart. */
  CART = 'CART',
  /** Opened from the "already purchased" section – modify an existing booking. */
  ALREADY_PURCHASED = 'ALREADY_PURCHASED',
}

export enum DiningReservationMode {
  /** No timeslot required by the restaurant (e.g. single-seating venues). */
  WITHOUT_TIMESLOT = 'WITHOUT_TIMESLOT',
  /** Timeslot selection is required (date + time steps added). */
  WITH_TIMESLOT = 'WITH_TIMESLOT',
}

export enum DiningStepId {
  PAX_SELECTION = 'PAX_SELECTION',
  CHOOSE_WHEN_BOOK = 'CHOOSE_WHEN_BOOK',
  DATE_TIME_SELECTION = 'DATE_TIME_SELECTION',
  RESERVATION_RECAP = 'RESERVATION_RECAP',
  DATE_SELECTION = 'DATE_SELECTION',
  TIME_SELECTION = 'TIME_SELECTION',
  CONFIRM = 'CONFIRM',
  SUCCESS = 'SUCCESS',
  CART_RESERVATION_RECAP = 'CART_RESERVATION_RECAP',
  PAX_SELECTION_EDIT = 'PAX_SELECTION_EDIT',
}

export enum DiningFlowEventType {
  NEXT = 'NEXT',
  BACK = 'BACK',
  SELECT_RESERVATION_MODE = 'SELECT_RESERVATION_MODE',
  EDIT_DATE_TIME = 'EDIT_DATE_TIME',
  EDIT_DATE = 'EDIT_DATE',
  EDIT_TIME = 'EDIT_TIME',
  EDIT_PAX = 'EDIT_PAX',
  EDIT_CHOOSE_WHEN_BOOK = 'EDIT_CHOOSE_WHEN_BOOK',
  RESET = 'RESET',
}

export enum ChooseWhenBookBannerVariant {
  NONE = 'NONE',
  RESERVATION_UNAVAILABLE = 'RESERVATION_UNAVAILABLE',
  GENERIC = 'GENERIC',
}
